import { render, staticRenderFns } from "./leavePeriodsList.vue?vue&type=template&id=479abfe7"
import script from "./leavePeriodsList.vue?vue&type=script&lang=js"
export * from "./leavePeriodsList.vue?vue&type=script&lang=js"
import style0 from "./leavePeriodsList.vue?vue&type=style&index=0&id=479abfe7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports